// Форма «Написать в поддержку» (handoff 02-screens f01-f24): категории, «встречает», правила
// «Отправить», поиск заказа.

export const TEXT_LIMIT = 1000

/** Порядок плиток 3×2 как на f01; short - подпись чипа категории в списках. */
export const CATEGORIES = [
  {
    code: 'orders_delivery',
    label: 'Заказы и доставка',
    short: 'Заказы и доставка',
    icon: 'mdi-truck-outline',
    greet: null,
  },
  {
    code: 'hardware',
    label: 'Терминалы, принтеры, оборудование',
    short: 'Оборудование',
    icon: 'mdi-printer-outline',
    greet: {
      question: 'Опишите, что за устройство и в чём проблема',
      hint: 'Желательно приложите фото устройства, чека или экрана с ошибкой',
    },
  },
  {
    code: 'menu',
    label: 'Проблема с меню',
    short: 'Меню',
    icon: 'mdi-book-open-variant',
    greet: {
      question: 'Какое блюдо или раздел?',
      hint: 'Название как в меню и где ошибка: в CRM, на сайте или в приложении',
    },
  },
  {
    code: 'aggregators',
    label: 'Агрегаторы и внешние источники заказов',
    short: 'Агрегаторы',
    icon: 'mdi-hub-outline',
    greet: {
      question: 'Какой агрегатор и что происходит?',
      hint: 'Опишите максимально подробно',
    },
  },
  {
    code: 'idea',
    label: 'Предложить идею',
    short: 'Идея',
    icon: 'mdi-lightbulb-outline',
    greet: {
      question: 'Что сделать удобнее?',
      hint: 'Мы обязательно её рассмотрим. Идеи читает команда разработки FAKT.',
    },
  },
  {
    code: 'other',
    label: 'Другое',
    short: 'Другое',
    icon: 'mdi-dots-horizontal',
    greet: {
      question: 'Расскажите, что случилось',
      hint: 'Доступы, тариф, оплата FAKT, сотрудники - всё, что не подошло в выборе категорий выше',
    },
  },
]

export function category (code) {
  return CATEGORIES.find(c => c.code === code) || CATEGORIES[CATEGORIES.length - 1]
}

/**
 * «Отправить» оранжевая, как только выбраны обязательные поля: категория и для «Заказы и
 * доставка» заказ (или номер текстом, когда FAKT CRM не отвечает).
 */
export function canSend ({ category: code, order = null, orderNumber = null }) {
  if (!code) return false
  if (code !== 'orders_delivery') return true

  return Boolean(order?.id || (orderNumber && orderNumber.trim()))
}

/** Нажатие «Отправить»: пустое поле - фокус в него и ничего не шлём (Q22). */
export function sendAction (state) {
  if (!canSend(state)) return 'blocked'

  return (state.text || '').trim() ? 'send' : 'focus'
}

/** Цифры номера для поиска; меньше трёх - не ищем (бэк ответит query_too_short). */
export function searchQuery (input) {
  const digits = String(input || '').replace(/\D/g, '')

  return digits.length >= 3 ? digits : null
}

/** «№5710» с жирным совпадением: [{ text, hit }]. */
export function highlight (number, query) {
  const value = String(number)
  const index = query ? value.indexOf(query) : -1
  if (index < 0) return [{ text: value, hit: false }]

  return [
    { text: value.slice(0, index), hit: false },
    { text: query, hit: true },
    { text: value.slice(index + query.length), hit: false },
  ].filter(part => part.text !== '')
}

/** Шапка результатов поиска: «Найдено 5 заказов», «Найден 1 заказ», «Найдено 3 заказа». */
export function foundText (n) {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return `Найден ${n} заказ`
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return `Найдено ${n} заказа`

  return `Найдено ${n} заказов`
}
